import { getCookie, getDvid, getXrequestId, saveServerLogs } from 'UtilityComponents/Util';
import { APPLICATION_CONSTANTS, PATHS } from 'AppConstants';
import { getccbAxiosConfig } from '../apisSetup/ccbConfig';
import { getmybizAxiosConfig } from '../apisSetup/myBizConfig';
import { getAbExperiment } from '../apis/commonApis';
import { formatBuisnessDets } from './utils';

const ccbAxiosApiCaller = getccbAxiosConfig(true, {}, false);
const mybizAxiosApiCaller = getmybizAxiosConfig(true);

export const getLandingExperiment = async () => {
	const abPlatformApi = APPLICATION_CONSTANTS.MYBIZ_CORE;
	response = await getAbExperiment( abPlatformApi).then((res) => res).catch((err) => {
		throw (err);
	});
	return response;
};

const getDataCall = async (url, data) => {
	let response = null;
	try {
		response = await ccbAxiosApiCaller.get(url, {
			params: data
		});
	} catch (e) {
		const errorMsg = e ? e.message : APPLICATION_CONSTANTS.API_ERROR;
		response = { error: errorMsg };
		saveServerLogs(e.stack, 'error', url, data);
	}
	return response;
};

export const getMyBizDetails = async (pageName) => {
	const response = await getDataCall(PATHS.GET_MYBIZ_ORGS_DET + '?pageName=' + pageName);
	const retData = formatBuisnessDets(response);
	return {
		bizDetails: retData
	};
};

export const getLandingSMEDetails = async () => {
	const retData = formatBuisnessDets({ data: SME_FEST_DATA });
	return {
		bizDetails: retData
	};
};

export const getMyBizBenefits = async (type) => {
	const response = await getDataCall(PATHS.GET_MYBIZ_BENEFITS, { type });
	const responseData = response && response.data;
	if (responseData && responseData.responseCode === APPLICATION_CONSTANTS.SUCCESS_RESPONSE_CODE && responseData.benefits) {
		return {
			bizBenefits: responseData
		};
	} else return false;
};

export const getMyBizTestimony = async () => {
	const response = await getDataCall(PATHS.GET_MYBIZ_TESTIMONY);
	let retData = { error: true };
	const responseData = response && response.data;
	if (responseData && responseData.responseCode === APPLICATION_CONSTANTS.SUCCESS_RESPONSE_CODE) {
		retData = responseData.testimoniesDetails;
	}
	return {
		bizTestimony: retData
	};
};

export const getMybizQuestions = async () => {
	const response = await getDataCall(PATHS.GET_MYBIZ_QUESTIONS);
	let retData = { error: true };
	const responseData = response && response.data;
	if (responseData && responseData.responseCode === APPLICATION_CONSTANTS.SUCCESS_RESPONSE_CODE) {
		retData = responseData.details;
	}
	return {
		bizQues: retData
	};
};

export const getMybizCaseStudy = async () => {
	const response = await getDataCall(PATHS.GET_MYBIZ_CASESTUDY);
	let retData = { error: true };
	const responseData = response && response.data;
	if (responseData && responseData.responseCode === APPLICATION_CONSTANTS.SUCCESS_RESPONSE_CODE) {
		retData = responseData.caseStudiesDetails;
	}
	return {
		caseStudy: retData
	};
};

export const getPrepGuidlinse = async (data) => {
	let response = null;
	try {
		response = await ccbAxiosApiCaller.post(PATHS.GET_MYBIZ_GUIDLINES, data);
	} catch (e) {
		const errorMsg = e ? e.message : 'Something went wrong, please try again later';
		response = { error: errorMsg };
		saveServerLogs(e.stack, 'error', PATHS.GET_MYBIZ_GUIDLINES);
	}
	return response;
};

export const requestDemoApi = async (data) => {
	let response = null;
	try {
		response = await ccbAxiosApiCaller.post(PATHS.REQUEST_DEMO_FORM, data);
	} catch (e) {
		const errorMsg = e ? e.message : 'Something went wrong, please try again later';
		response = { error: errorMsg };
		saveServerLogs(e.stack, 'error', PATHS.GET_MYBIZ_GUIDLINES);
	}
	return response;
};

export const userVerify = async (data) => {
	let response = null;
	try {
		response = await ccbAxiosApiCaller.put(PATHS.VERIFY_USER, data);
	} catch (e) {
		const errorMsg = e ? e.message : APPLICATION_CONSTANTS.API_ERROR;
		response = { error: errorMsg };
		saveServerLogs(e.stack, 'error', url, data);
	}
	return response;
};

export const getConfigData = async (configType) => {
	const response = await getDataCall(PATHS.GET_CONFIG + configType);
	let retData = { error: true };
	const responseData = response && response.data;
	if (responseData && responseData.responseCode === APPLICATION_CONSTANTS.SUCCESS_RESPONSE_CODE) {
		retData = responseData?.config;
	}
	return {
		data: retData
	};
};

export const getReferralData = async (data) => {
	let referralData = { error: true };
	try {
		const response = await ccbAxiosApiCaller.get(PATHS.GET_REFERRAL_DATA + data);
		const responseData = response && response.data;
		if (responseData && responseData.responseCode === APPLICATION_CONSTANTS.SUCCESS_RESPONSE_CODE) {
			return responseData;
		}
	} catch (error) {
		saveServerLogs(error.stack, 'error', PATHS.GET_REFERRAL_DATA + data);
		return referralData;
	}
};

export const getChatResponseStream = async (data, streamCallback) => {
	let response = null;
	try {
		response = await fetch(PATHS.MYBIZ_CHAT_API, {
			method: 'POST',
			body: JSON.stringify(data),
			headers: {
				'Content-Type': 'application/json',
				'mmt-auth': getCookie('mmt-auth'),
				'x-request-id': getXrequestId(),
				'deviceId': getDvid()
			}
		});
	} catch (error) {

	}

	const reader = response.body.getReader();
	const decoder = new TextDecoder('utf-8');

	let buffer = '';

	while (true) {
		const { done, value } = await reader.read();
		if (done) break;

		buffer += decoder.decode(value, { stream: true });

		// Try to parse JSON objects as they arrive
		let boundary;
		while ((boundary = buffer.indexOf('\n')) >= 0) {
			let chunk = buffer.slice(0, boundary).trim();
			chunk = chunk.split('data:')[1]?.trim() || chunk;
			buffer = buffer.slice(boundary + 1);
			if (chunk) {
				try {
					streamCallback(JSON.parse(chunk));
				} catch {
					streamCallback(chunk);
				}
			}
		}
	}
	if (response?.status > 300) {
		throw ({
			status: response.status,
			message: response.statusText
		});
	}
};

export const getChatResponse = async (data) => {
	try {
		const response = await mybizAxiosApiCaller.post(PATHS.MYBIZ_CHAT_API, data);
		const responseData = response && response.data;
		if (responseData.data) {
			return responseData;
		} else {
			return { data: { message: 'Seems like server issue' } };
		}
	} catch (error) {
		saveServerLogs(error.stack, 'error', 'http://127.0.0.1:3000/chat-agent');
		return { answer: 'Seems like server issue' };
	}
};

export const getChatHistory = async () => {
	try {
		const response = await mybizAxiosApiCaller.get(PATHS.FETCH_CHAT_HISTORY);
		const responseData = response && response.data;
		let isActionAvailable = false;
		const msgLength = responseData?.messages?.length;
		const messages = responseData?.messages?.filter((msg, index) => {
			const isLastMessage = index === msgLength - 1;
			if (msg.type === 'ToolMessage' && msg.content.toLowerCase().includes('error')) {
				return false;
			}
			if (msg.content.includes('reject_btn') && !isLastMessage) {
				return false;
			}
			return true;
		})?.map((msg) => {
			let content = msg.content;
			let status = '';
			let approveBtn = false;
			let rejectBtn = false;
			try {
				const messageData = JSON.parse(content);
				content = msg.type === 'ToolMessage' ? messageData.messages[0] : messageData.message;
				status = messageData.status;
				approveBtn = messageData.approve_btn;
				rejectBtn = messageData.reject_btn;
			} catch (e) {
			}
			isActionAvailable = !!( approveBtn || rejectBtn);
			return {
				text: content,
				sender: msg.type === 'HumanMessage' ? 'user' : 'bot',
				status: status,
				actions: {
					approve: approveBtn,
					reject: rejectBtn
				}
			};
		});
		return { messages, isActionAvailable };
	} catch (error) {
		saveServerLogs(error.stack, 'error', 'http://127.0.0.1:3000/chat-agent');
		return { answer: 'Seems like server issue' };
	}
};
